import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import chevLeft from "./assets/chev-left.svg";

export default ({ items }) => (
  <Link
    to="/"
    className="dn-ns flex items-center bb b--moon-gray no-underline ph3 pv2"
  >
    <img src={chevLeft} className="mr3 flex-start" alt="back to insiders" />
    <Back>Back to Insiders</Back>
  </Link>
);

const Back = styled.span`
  @media (max-width: 680px) {
    font-size: 1.3rem;
    color: #a1a19f;
    font-family: "CircularStd-Book", sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/BackTo/index.js